import React from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ isOpen, onClose, title, children, maxWidth = '500px', bodyStyle = {} }) => {
  if (!isOpen) return null;

  const backdropStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const modalStyle = {
    background: 'var(--bg-secondary)',
    borderRadius: '12px',
    padding: '24px 30px',
  width: '90%',
  maxWidth,
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    position: 'relative',
    zIndex: 1001,
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid var(--border-color)',
    paddingBottom: '15px',
    marginBottom: '20px',
  };

  const titleStyle = {
    margin: 0,
    fontSize: '1.25rem',
    fontWeight: 600,
    color: 'var(--text-primary)',
  };

  const closeButtonStyle = {
    background: 'none',
    border: 'none',
    fontSize: '1.8rem',
    cursor: 'pointer',
    color: 'var(--text-secondary)',
    lineHeight: 1,
  };

  const mergedBodyStyle = {
    maxHeight: 'calc(80vh - 84px)',
    overflowY: 'auto',
    paddingRight: '0.35rem',
    ...bodyStyle
  };

  return ReactDOM.createPortal(
    <div style={backdropStyle} onClick={onClose}>
      <div style={modalStyle} onClick={e => e.stopPropagation()}>
        <div style={headerStyle}>
          <h2 style={titleStyle}>{title}</h2>
          <button onClick={onClose} style={closeButtonStyle}>&times;</button>
        </div>
        <div style={mergedBodyStyle}>
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
